import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Biotechnology PhD Students</h1>
                <p>Home &gt; Research &gt; Biotechnology PhD Student</p>
            </div>
        </div>
    );
};

export default Hero;
